import {
	Autocomplete,
	Box
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTheme } from '@mui/material/styles';

import CustomTextFieldIndex from './CustomTextFieldIndex';

const CustomAutocompleteIndex = ({ renderInputProps, onChange, ...props }: any) => {
	const theme = useTheme();
	const colors = theme.palette;

	const autocompleteSx = {
		width: '100%',

		'& .MuiOutlinedInput-root': {
			backgroundColor: `${colors.DropdownV2.background} !important`,
			color: `${colors.DropdownV2.menuItemText} !important`,

			'& fieldset': {
				borderColor: `${colors.DropdownV2.borderColor} !important`
			},

			'&:hover fieldset': {
				borderColor: `${colors.DropdownV2.borderColorHover} !important`
			},

			'&.Mui-focused fieldset': {
				borderColor: `${colors.DropdownV2.borderColorActive} !important`,
				borderWidth: '1px'
			}
		},

		'& .MuiInputBase-input': {
			color: `${colors.DropdownV2.menuItemText} !important`,
			WebkitTextFillColor: `${colors.DropdownV2.menuItemText} !important`
		},

		'& .MuiInputLabel-root': {
			color: `${colors.inputNew.inputPlaceholder} !important`
		},

		'& .MuiInputLabel-root.Mui-focused': {
			color: `${colors.inputNew.labelText} !important`
		},

		'& .MuiAutocomplete-popupIndicator': {
			color: `${colors.DropdownV2.dropdownIconDefault} !important`
		},

		'& .MuiAutocomplete-popupIndicatorOpen': {
			color: `${colors.DropdownV2.dropdownIconActive} !important`
		},

		'& .MuiAutocomplete-popupIndicator svg': {
			color: 'inherit !important',
			width: '22px',
			height: '22px'
		},

		'& .MuiAutocomplete-clearIndicator': {
			color: `${colors.DropdownV2.dropdownIconDefault} !important`
		},

		'& .MuiOutlinedInput-root.Mui-focused .MuiAutocomplete-popupIndicator': {
			color: `${colors.DropdownV2.dropdownIconActive} !important`
		}
	};

	const dropdownPaperSx = {
		mt: 1,
		overflow: 'hidden',
		backgroundColor: `${colors.DropdownV2.menuItemBackground} !important`,
		color: `${colors.DropdownV2.menuItemText} !important`,
		boxShadow: '0px 8px 24px rgba(16, 24, 40, 0.12)',

		'& .MuiAutocomplete-listbox': {
			padding: 0,
			backgroundColor: `${colors.DropdownV2.menuItemBackground} !important`
		},

		'& .MuiAutocomplete-option': {
			backgroundColor: `${colors.DropdownV2.menuItemBackground} !important`,
			color: `${colors.DropdownV2.menuItemText} !important`,
			WebkitTextFillColor: `${colors.DropdownV2.menuItemText} !important`,
			padding: '10px 16px',
			minHeight: '48px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			gap: '12px',
			opacity: 1
		},

		'& .MuiAutocomplete-option .dropdown-option-text': {
			color: `${colors.DropdownV2.menuItemText} !important`,
			WebkitTextFillColor: `${colors.DropdownV2.menuItemText} !important`
		},

		'& .MuiAutocomplete-option:hover': {
			backgroundColor: `${colors.DropdownV2.menuItemHover} !important`,
			color: `${colors.DropdownV2.menuItemHoverText} !important`,
			WebkitTextFillColor: `${colors.DropdownV2.menuItemHoverText} !important`
		},

		'& .MuiAutocomplete-option:hover .dropdown-option-text': {
			color: `${colors.DropdownV2.menuItemHoverText} !important`,
			WebkitTextFillColor: `${colors.DropdownV2.menuItemHoverText} !important`
		},

		'& .MuiAutocomplete-option.Mui-focused, & .MuiAutocomplete-option.Mui-focusVisible': {
			backgroundColor: `${colors.DropdownV2.menuItemHover} !important`,
			color: `${colors.DropdownV2.menuItemHoverText} !important`,
			WebkitTextFillColor: `${colors.DropdownV2.menuItemHoverText} !important`
		},

		'& .MuiAutocomplete-option.Mui-focused .dropdown-option-text, & .MuiAutocomplete-option.Mui-focusVisible .dropdown-option-text': {
			color: `${colors.DropdownV2.menuItemHoverText} !important`,
			WebkitTextFillColor: `${colors.DropdownV2.menuItemHoverText} !important`
		},

		'& .MuiAutocomplete-option[aria-selected="true"]': {
			backgroundColor: `${colors.DropdownV2.menuItemSelectedBg} !important`,
			color: `${colors.DropdownV2.menuItemSelectedText} !important`,
			WebkitTextFillColor: `${colors.DropdownV2.menuItemSelectedText} !important`
		},

		'& .MuiAutocomplete-option[aria-selected="true"] .dropdown-option-text': {
			color: `${colors.DropdownV2.menuItemSelectedText} !important`,
			WebkitTextFillColor: `${colors.DropdownV2.menuItemSelectedText} !important`
		},

		'& .MuiAutocomplete-option[aria-selected="true"]:hover, & .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
			backgroundColor: `${colors.DropdownV2.menuItemSelectedBg} !important`,
			color: `${colors.DropdownV2.menuItemSelectedText} !important`,
			WebkitTextFillColor: `${colors.DropdownV2.menuItemSelectedText} !important`
		},

		'& .MuiAutocomplete-option[aria-selected="true"]:hover .dropdown-option-text, & .MuiAutocomplete-option[aria-selected="true"].Mui-focused .dropdown-option-text': {
			color: `${colors.DropdownV2.menuItemSelectedText} !important`,
			WebkitTextFillColor: `${colors.DropdownV2.menuItemSelectedText} !important`
		},

		'& .dropdown-option-check': {
			color: `${colors.DropdownV2.tickColor} !important`
		},

		'& .dropdown-option-check path': {
			fill: `${colors.DropdownV2.tickColor} !important`
		},

		'& .MuiAutocomplete-noOptions': {
			backgroundColor: `${colors.DropdownV2.menuItemBackground} !important`,
			color: `${colors.DropdownV2.mutedText} !important`,
			WebkitTextFillColor: `${colors.DropdownV2.mutedText} !important`
		}
	};

	const getOptionLabel = props.getOptionLabel
		? props.getOptionLabel
		: (option: any) => option?.label ?? '';

	return (
		<Autocomplete
			{...props}
			popupIcon={<KeyboardArrowDownIcon />}
			sx={{
				...autocompleteSx,
				...props.sx
			}}
			componentsProps={{
				paper: {
					sx: dropdownPaperSx
				},
				popupIndicator: {
					sx: {
						color: `${colors.DropdownV2.dropdownIconDefault} !important`,

						'&:hover': {
							backgroundColor: 'transparent'
						}
					}
				},
				clearIndicator: {
					sx: {
						color: `${colors.DropdownV2.dropdownIconDefault} !important`,

						'&:hover': {
							backgroundColor: 'transparent'
						}
					}
				}
			}}
			onChange={(event, value) => onChange(value)}
			renderOption={(optionProps, option, { selected }) => (
				<Box
					component="li"
					{...optionProps}
				>
					<Box
						component="span"
						className="dropdown-option-text"
						sx={{
							flex: 1,
							color: selected
								? `${colors.DropdownV2.menuItemSelectedText} !important`
								: `${colors.DropdownV2.menuItemText} !important`,
							WebkitTextFillColor: selected
								? `${colors.DropdownV2.menuItemSelectedText} !important`
								: `${colors.DropdownV2.menuItemText} !important`
						}}
					>
						{getOptionLabel(option)}
					</Box>

					{selected ? (
						<CheckIcon
							className="dropdown-option-check"
							sx={{
								fontSize: '22px',
								color: `${colors.DropdownV2.tickColor} !important`,
								flexShrink: 0
							}}
						/>
					) : null}
				</Box>
			)}
			renderInput={(params) => (
				<CustomTextFieldIndex
					{...params}
					{...renderInputProps}
				/>
			)}
		/>
	);
};

export default CustomAutocompleteIndex;